"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOnTertiary = exports.getOnSecondary = exports.getOnPrimary = exports.getTertiaryContainer = exports.getSecondaryContainer = exports.getPrimaryContainer = void 0;
var colors_1 = require("../colors");
var primaryContainer = colors_1.colors.primaryContainer, secondaryContainer = colors_1.colors.secondaryContainer, tertiaryContainer = colors_1.colors.tertiaryContainer, onPrimary = colors_1.colors.onPrimary, onSecondary = colors_1.colors.onSecondary, onTertiary = colors_1.colors.onTertiary;
/**
* Get the primary Container color.
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getPrimaryContainer = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.primaryContainer) || primaryContainer;
};
exports.getPrimaryContainer = getPrimaryContainer;
/**
*  Get the secondary Container color.
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getSecondaryContainer = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.secondaryContainer) || secondaryContainer;
};
exports.getSecondaryContainer = getSecondaryContainer;
/**
* get the tertiary Container color..
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getTertiaryContainer = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.tertiaryContainer) || tertiaryContainer;
};
exports.getTertiaryContainer = getTertiaryContainer;
/**
* Get the onPrimary color.
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getOnPrimary = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.onPrimary) || onPrimary;
};
exports.getOnPrimary = getOnPrimary;
/**
* Get the onSecondary color.
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getOnSecondary = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.onSecondary) || onSecondary;
};
exports.getOnSecondary = getOnSecondary;
/**
* Get the onTertiary color.
*
* @param {ColorsType} colors - Optional colors object
* @return {string} The primary color text
*/
var getOnTertiary = function (colors) {
    return (colors === null || colors === void 0 ? void 0 : colors.onTertiary) || onTertiary;
};
exports.getOnTertiary = getOnTertiary;
